import styled, { css } from 'styled-components';

import { colors } from 'theme';

interface HorizontalRulerProps {
  highlighted?: boolean;
}
const HorizontalRuler = styled.hr<HorizontalRulerProps>`
  border: solid 0 ${colors.grey_300};
  border-bottom-width: 1px;

  ${({ highlighted = false }) =>
    highlighted &&
    css`
      border-color: ${colors.blueGrey};
    `}
`;

export default HorizontalRuler;
